import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Copy from '../../../assets/copy.svg';
//import QrCode from '../../../assets/imgQR_code.jpeg';
import {QRCodeSVG} from 'qrcode.react';
import { getStrLang } from '../../Translate';
import Loading from '../../../assets/loading.gif';
import { useHistory, useLocation } from 'react-router-dom';
import { getAceiteTermos, getPixInfo } from '../../../api/fastcoinService';
import toast, { Toaster } from 'react-hot-toast';
import 'jquery-ui-dist/jquery-ui';
import { AiOutlineSplitCells } from 'react-icons/ai';

const PixDefault = (props) => {
    //Chamada para as variáveis e funções do Context
    const pix_avaliable = true;
    const { translate, lang, orderFromDeposit } = useLanguage();
    const [infoPix, setInfoPix] = useState(sessionStorage.getItem("pix_info") !== null ? JSON.parse(sessionStorage.getItem("pix_info")) : undefined);
    const [loadingPixInfo, setLoadingPixInfo] = useState(false);
    const [client_logo,set_client_logo]=useState('')

    //valida se os termos da ordem foram aceitos 
    useEffect(() => {
        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    //console.log(res);
                    if (res !== undefined) {
                        sessionStorage.setItem("showTermos_deposit", false);
                        props.setShowTermos(false);
                        translate();
                    } else {
                        sessionStorage.setItem("showTermos_deposit", true);
                        props.setShowTermos(true);
                    }
                })
                .catch(err => {
                    if (err.error.includes("Could not find the term")) {
                        sessionStorage.setItem("showTermos_deposit", true);
                        props.setShowTermos(true);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                })
        }
        if (orderFromDeposit !== "") {
            gerarPix();
            validarTermos();
        }
        const logoData=sessionStorage.getItem('client_logo')
        if(logoData){
            set_client_logo(logoData)
        }else{
            if(sessionStorage.getItem('is_white_label') === "true"){
            }else{
                set_client_logo('favicon.ico')
            }
        }
    }, []);

    //Traduz o texto na tela quando mudado o idioma pelo usuário
    useEffect(() => {
        translate();
    }, [translate]);


    function gerarPix() {
        function executarGeracaoPix() {
            let orderNumber = sessionStorage.getItem("order_no");
            let valor = sessionStorage.getItem("order_amount");
            let isUsdtPixPayment=props.isUsdtPixPayment?true:false
            getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor,false,false,isUsdtPixPayment)
                .then(res => {
                    if (res !== undefined) {
                        setInfoPix(res);
                        sessionStorage.setItem("pix_info", JSON.stringify(res));
                        props.setWaitingPayment(true);
                    } else {
                        setInfoPix({ error: "Please, talk with the Administrator." });
                    }
                    setLoadingPixInfo(false);
                    translate();
                })
                .catch(err => {
                    getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor, true,false,isUsdtPixPayment)
                        .then(res => {
                            if (res !== undefined) {
                                setInfoPix(res);
                                sessionStorage.setItem("pix_info", JSON.stringify(res));
                                props.setWaitingPayment(true);
                            } else {
                                setInfoPix({ error: "Please, talk with the Administrator." });
                            }
                            setLoadingPixInfo(false);
                            translate();
                        })
                        .catch(err => {
                            getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor, false,true,isUsdtPixPayment)
                                .then(res => {
                                    if (res !== undefined) {
                                        setInfoPix(res);
                                        sessionStorage.setItem("pix_info", JSON.stringify(res));
                                        props.setWaitingPayment(true);
                                    } else {
                                        setInfoPix({ error: "Please, talk with the Administrator." });
                                    }
                                    setLoadingPixInfo(false);
                                    translate();
                                })
                                .catch(err => {
                                    setInfoPix({ emv: "00020101021126580014br.gov.bcb.pix0136c9834cf4-31d3-4e14-9f03-7f6876e7cd215204000053039865802BR5912Mercado Easy6009SAO PAULO622905251H5WTE0YNK59CZ0FHZYGHMAB16304F73B" });
                                    console.log(err);
                                    setLoadingPixInfo(false);
                                    translate();
                                })
                        })
                })
        }
        if (infoPix === undefined) {
            setLoadingPixInfo(true);
            executarGeracaoPix();
        }
    }

    const notify = () => {
        navigator.clipboard.writeText(infoPix.emv);
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }

    return (

        <div className={`${props?.hideSplit !==true?'grup-splited-opt':''}`}>
            {props?.hideSplit !==true && <div className="column-pix-sides">
                <button className="btn-split-pix" onClick={() => [props.setTelaPix("slide"), props.setWaitingPayment(true)]}><AiOutlineSplitCells size={40}/> {getStrLang(lang.nameLang, "btn_dividir")}</button>
            </div>}
            <div className={`${props?.hideSplit !==true?'msg-pix':'msg-pix2'}`}>
                {pix_avaliable ?
                    <>
                        {infoPix !== undefined && infoPix.emv !== undefined ?
                            <>
                                {<QRCodeSVG value={infoPix.emv} size={180} imageSettings={{src:client_logo,height:40,width:40}}/>}
                                {/* <img src={QrCode} alt={"QrCode"} width="180px" height="180px" />*/}
                                <div style={{ display: 'flex', flexDirection: 'row', width: '60%', alignItems: 'center', justifyContent: 'center' }}>
                                    <div className="form-group form-inputs">
                                        <label htmlFor={"pix_info"} data-lang-str={props.data_lang_label} className="bold_text_ted"></label>
                                        <div className="input-line-pix">
                                            <input type="text" id={"pix_info"} className="form-control form-control-lg" value={infoPix.emv} />
                                            <div className="copy-area-pix" onClick={() => notify()} data-balloon-visible aria-label={getStrLang(lang.nameLang, "information_pix_copy")} data-balloon-pos="down">
                                                <img src={Copy} alt="Copy" />
                                                <Toaster
                                                    toastOptions={{
                                                        className: '',
                                                        style: {
                                                            border: '1px solid #0d4fb8',
                                                            color: '#0d4fb8',
                                                            padding: '12px',
                                                            top: '300px',
                                                            //  position: 'relative',
                                                        },
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                {loadingPixInfo ?
                                    <img src={Loading} alt={"loading"} width="30px" height="30px" />
                                    :
                                    <></>
                                }
                            </>
                        }
                        {/* <h4 className="div-info-pag" data-lang-str="information_pix"></h4>*/}
                    </>
                    :
                    <h4 data-lang-str="information_pix"></h4>
                }

            </div>
            <div className="column-pix-sides"></div>
        </div>

    )
}

export default PixDefault;